import config from 'config';

import type { HeaderSigningKey, KeyServiceConfig, ViewerConfig } from './core';

const KEY_API_ORIGIN = /^https:\/\/[a-z0-9]([a-z0-9.-]*[a-z0-9])?$/;

const isSigningKey = (value: unknown): value is HeaderSigningKey => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const { kid, jwk } = value as { kid?: unknown; jwk?: unknown };
  if (typeof kid !== 'string' || kid.length === 0 || typeof jwk !== 'object' || jwk === null) {
    return false;
  }
  const { kty, crv, x, y, d } = jwk as Record<string, unknown>;
  return (
    kty === 'EC' &&
    crv === 'P-256' &&
    typeof x === 'string' &&
    typeof y === 'string' &&
    d === undefined
  );
};

const irmSectionOf = (source: object) =>
  (source as { irm?: { KEY_SERVICE_URL?: unknown; HEADER_SIGNING_KEYS?: unknown } }).irm;

export function readKeyServiceConfig(source: object): KeyServiceConfig | undefined {
  const url = irmSectionOf(source)?.KEY_SERVICE_URL;
  if (typeof url !== 'string' || !KEY_API_ORIGIN.test(url)) {
    return undefined;
  }
  return { keyApiBaseUrl: url };
}

export function readViewerConfig(source: object): ViewerConfig | undefined {
  const keyService = readKeyServiceConfig(source);
  if (!keyService) {
    return undefined;
  }
  const keys = irmSectionOf(source)?.HEADER_SIGNING_KEYS;
  if (!Array.isArray(keys) || keys.length === 0 || !keys.every(isSigningKey)) {
    return undefined;
  }
  return { ...keyService, headerSigningKeys: [...keys] };
}

export const viewerConfig = readViewerConfig(config);

// A loan table view needs only the key service: no envelope header is verified on this page.
export const keyServiceConfig = readKeyServiceConfig(config);
